// Copyright (c) 2025 Deere & Company

import MeasurementReading, {getDefaultState as getMeasurementReadingDefaultState} from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import React, {PropTypes} from 'react';
import AmountOfUseResult from './update-amount-of-use-results';
import AmountOfUseUpdateModal from './update-amount-of-use-modal';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../../shared/state/search-filters';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import amountOfUseRequestSortOptions from '../../services/amount-of-use-request-sort-options';

const UpdateAmountOfUseListItem = props => {

    const handleCloseAmountOfUseModal = () => {

        props.actions.closeAmountOfUseModal();
        props.actions.amountOfUseItemToUpdate(getMeasurementReadingDefaultState());

    };

    const handleCommentsToDealerChange = comments => {

        props.actions.commentsToDealerUpdate(comments);

    };

    const handleInternalDeereCommentsChange = comments => {

        props.actions.internalDeereCommentsUpdate(comments);

    };

    const handleAmountOfUseModalConfirmation = (actionToTake, itemToUpdate) => {

        props.actions.approveDenyAmountOfUse(actionToTake, itemToUpdate, props.selectedDealers);

    };

    const handleOpenUpdateAmountOfUseModal = (amountOfUse, actionToTake) => {

        props.actions.amountOfUseItemToUpdate(amountOfUse);
        props.actions.openAmountOfUseModal(actionToTake);

    };

    return (
        <div>
            <RefinableListWidget
                onFilterByChange={props.onFilterByChange}
                onSortByChange={props.onSortByChange}
                onSortDirectionChange={props.onSortDirectionChange}
                searchFilters={props.amountOfUseRequestSearchFilters}
                sortOptions={amountOfUseRequestSortOptions}
            />
            {props.amountOfUseRequests.map((amountOfUse, index) =>
                <AmountOfUseResult
                    actions={props.actions}
                    amountOfUse={amountOfUse}
                    key={index}
                    openUpdateStatusChangeModal={handleOpenUpdateAmountOfUseModal}
                    selectedDealers={props.selectedDealers}
                />
            )}
            <AmountOfUseUpdateModal
                amountOfUseModal={props.amountOfUseModal}
                amountOfUseRequestItemToUpdate={props.amountOfUseRequestItemToUpdate}
                closeUpdateAmountOfUseModal={handleCloseAmountOfUseModal}
                onCommentsToDealerChange={handleCommentsToDealerChange}
                onConfirmation={handleAmountOfUseModalConfirmation}
                onInternalDeereCommentsChange={handleInternalDeereCommentsChange}
            />
        </div>
    );

};

UpdateAmountOfUseListItem.displayName = 'UpdateAmountOfUseListItem';
UpdateAmountOfUseListItem.propTypes = {
    actions: PropTypes.object.isRequired,
    amountOfUseModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    amountOfUseRequestItemToUpdate: PropTypes.instanceOf(MeasurementReading).isRequired,
    amountOfUseRequestSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    amountOfUseRequests: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onFilterByChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
    onSortDirectionChange: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String))
};

export default UpdateAmountOfUseListItem;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/update-amount-of-use/update-amount-of-use-list-item.js